import { render, staticRenderFns } from "./HighligtedHex.vue?vue&type=template&id=40b38487&"
import script from "./HighligtedHex.vue?vue&type=script&lang=ts&"
export * from "./HighligtedHex.vue?vue&type=script&lang=ts&"
import style0 from "./HighligtedHex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports